import { useEffect } from 'react';

function TitleChange(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default TitleChange;